import { ListActionButton } from '@europrocurement/flexy-components';
import { MediaObject } from '@europrocurement/l2d-domain';
import { downloadIcon, FaOptionIcon } from '@europrocurement/l2d-icons';
import React from 'react';

type DownloadButtonProps = {
    mediaObject: MediaObject;
};

export const downloadContentName = (mediaObjectToDownload: {
    contentUrl?: string | null;
    name?: string | null;
}) => {
    if (mediaObjectToDownload.contentUrl && mediaObjectToDownload.name) {
        const link = document.createElement('a');
        link.href = mediaObjectToDownload.contentUrl;
        link.target = '_blank';
        link.type = 'application/octet-stream';
        link.download = `${mediaObjectToDownload.name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

const DownloadButton: React.FunctionComponent<DownloadButtonProps> = function ({
    mediaObject,
}: DownloadButtonProps) {
    /**
     * Action lors du clique du bouton de téléchargement du PDF.
     */

    return (
        <ListActionButton
            tooltip="Télécharger"
            onClick={() => {
                downloadContentName(mediaObject);
            }}
            iconComponent={<FaOptionIcon {...downloadIcon.props} />}
        />
    );
};

export default DownloadButton;
